import React, { useContext } from "react";

export const DEFAULT_THEMES = {
  light: {
    primary: "#2A54FC",
    elementBackground: "#FFFFFF",
    border: "#F3F3F3",
    positive: "#06d6a0",
    danger: "#ed0d32",
    text: "#090025",
  },
  dark: {
    primary: "#2A54FC",
    elementBackground: "#222223",
    border: "#333333",
    positive: "#06d6a0",
    danger: "#ed0d32",
    text: "#fcfcfc",
  },
};

export interface ThemeColors {
  primary: string;
  elementBackground: string;
  border: string;
  positive: string;
  danger: string;
  text: string;
}

export const ThemeContext = React.createContext<ThemeColors>({
  ...DEFAULT_THEMES.light,
});

export const useTheme = () => {
  return useContext(ThemeContext);
};
